module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Content_FlashPlayer_MobileFormatSwitcher', {
		configure: function () {
			this._isOpened = false;

			this.registerOptions('', {
				autoRender: false,
				embed: {
					widget: '@parent @parent #currentScene #list',
					container: '.mobile-switcher'
				},
				template: 'player_mobile_format_switcher',

				handleWom: {
					changeFormat: {
						widget: '@parent',
						event: '_changeFormat',
						callback: '_prepareFormatsList'
					},
					formatsDataReady: {
						widget: '@this',
						event: 'formatsDataReady',
						callback: '_handleFormatsReadyStatus'
					},

					play: {
						widget: '@parent',
						event: 'player.play',
						callback: '_onPlay'
					},

					pause: {
						widget: '@parent',
						event: 'player.pause',
						callback: '_onPause'
					}
				},

				handleDom: {
					switchFormat: {
						target: '[data-format-alias]',
						event: 'click',
						callback: '_switchFormat'
					},
					toggle: {
						target: '.mc-mobile-format-switcher',
						event: 'click',
						callback: 'toggleList'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.player = this.wom1('@parent');

			$(window).on('click', {w: this}, this._hideList);

			this.callParent('running', arguments);
		},

		activate: function () {
			$(window).on('click', {w: this}, this._hideList);

			this.callParent('activate', arguments);
		},

		deactivate: function () {
			$(window).off('click', this._hideList);
			this.callParent('deactivate', arguments);
		},

		_prepareFormatsList: function () {
			this.formatsData = {
				current: null,
				list: []
			};

			var formats = this.getFormats();
			var current = this.getCurrentFormat();

			fox.each(formats, function (format, name) {
				if (name == current) {
					this.formatsData.current = format;

					return;
				}
				format.alias = name;
				this.formatsData.list.push(format);
			}, this);

			this.dispatchEvent('formatsDataReady');
		},

		_handleFormatsReadyStatus: function () {
			if (fox.count(this.formatsData.list) > 0) {
				this.setOption('templateOptions.formatsData', this.formatsData);
				this.render();

				return;
			}

			this.removeFromDom();
		},

		getFormats: function () {
			return this.player.getFormatMap().view;
		},

		getCurrentFormat: function () {
			return this.player.getVideoFormat();
		},

		_switchFormat: function (el, alias, w, e) {
			this.switchFormat(fox.dom.wrap(el).attr('data-format-alias'));
			this.closeList();
		},

		switchFormat: function (format) {
			this.player.changeFormat(format);
		},

		toggleList: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			if (this._isOpened) {
				this.closeList();

				return;
			}

			this.openList();
		},

		openList: function () {
			fox.dom.addClass('opened', this.dom1('.mc-mobile-format-switcher'));
			this._isOpened = true;
		},

		closeList: function () {
			fox.dom.removeClass('opened', this.dom1('.mc-mobile-format-switcher'));
			this._isOpened = false;
		},

		_hideList: function (e) {
			e.stopPropagation();
			e.data.w.closeList();
		},

		_onPlay: function () {
			if (this.element) {
				fox.dom.addClass('hide', this.element[0]);
			}
			
		},

		_onPause: function () {
			if (this.element) {
				fox.dom.removeClass('hide', this.element[0]);
			}
			
		}

	}, 'Widget');
})(fox);


 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/content/mobileFormatSwitcher.js
// module id = 450
// module chunks = 4